export default __webpack_public_path__ + "static/media/a008-6.a76939fe.svg";